/**
 * BrowserView — the specialist's browser (legacy portals with no API): latest JPEG frame, the URL
 * bar text, the action log (passwords arrive masked), and a "REST fallback" chip when the
 * Workbench posted through the REST route instead.
 */

import { Globe, MousePointerClick, Keyboard, Upload, Send, ArrowRight, X, RotateCcw } from 'lucide-react';
import './WorkbenchDrawer.css';

const ACTION_ICON = {
  open: Globe, goto: ArrowRight, click: MousePointerClick, type: Keyboard, upload: Upload,
  submit: Send, close: X, fallback: RotateCcw,
};

export default function BrowserView({ browser = null }) {
  if (!browser || (!browser.frame && !(browser.actions || []).length)) {
    return <div className="wbd__empty">The browser has not been used in this case.</div>;
  }
  const actions = browser.actions || [];
  return (
    <div className="wbd__browser">
      <div className="wbd__urlbar">
        <Globe size={12} aria-hidden="true" />
        <span className="wbd__url" title={browser.url}>{browser.url || 'about:blank'}</span>
        {browser.title && <span className="wbd__urltitle">{browser.title}</span>}
        {browser.fallback && <span className="wbd__chip" title="Posted through the REST route instead of the portal">REST fallback</span>}
      </div>
      <div className="wbd__browser-body">
        <div className="wbd__frame">
          {browser.frame ? (
            <img src={browser.frame} alt={`Browser view: ${browser.title || browser.url}`} />
          ) : (
            <div className="wbd__empty">No frame yet.</div>
          )}
        </div>
        <ol className="wbd__actions wbd__scroller" aria-label="Browser actions">
          {actions.map((a, i) => {
            const ActionIcon = ACTION_ICON[a.kind] ?? ArrowRight;
            return (
              <li key={i} className={`wbd__action is-${a.kind}`}>
                <ActionIcon size={11} aria-hidden="true" />
                <span className="wbd__action-kind">{a.kind}</span>
                {a.selector && <span className="wbd__action-sel">{a.selector}</span>}
                {a.value_preview && <span className="wbd__action-val">{a.value_preview}</span>}
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}
